import styles from './styles.module.scss'
import { FormPartInterface } from '../../../interfaces'
import { useClaimData, useUpdateClaimData } from '../../../claimProvider'
import SubmitButton from '../../buttons/SubmitButton'
import { Heading, Lead } from '../../ui/Text'

export const CompleteSigned = (props: FormPartInterface) => {
    const { isActive } = props
    const claim = useClaimData()
    const updateClaim = useUpdateClaimData()

    if (isActive !== 'complete') return <></>

    const startAnotherClaim = () => {
        updateClaim(undefined)
        // Full page load remounts EligibilityFlow + ClaimForm as a fresh user session
        window.location.assign('/')
    }

    return (
        <div className={styles.container}>
            <Heading align="center">Thank you!</Heading>
            <Lead align="center" className={styles.tagline}>
                Your hearing loss claim documents have been signed, and we have received your proof of ID and utility
                bill.
                <br />
                <br />
                {claim?.clientEmail ? (
                    <>
                        A signed copy has been emailed to{' '}
                        <span className={`${styles.emailHighlight} mf-excluded`}>{claim.clientEmail}</span> for your
                        records.
                    </>
                ) : (
                    <>A signed copy has been emailed to you for your records.</>
                )}
                <br />
                <br />
                A member of the Sentinel Legal team will be in touch soon.
            </Lead>
            <div className={styles.actions}>
                {/* Same glass button as the claim form's Next/Submit */}
                <SubmitButton onClick={startAnotherClaim} className={styles.anotherClaim}>
                    Submit another claim
                </SubmitButton>
            </div>
        </div>
    )
}
